export const heroesAudioEffects: Map<string, string> = new Map<string, string>([
  ['adventure_heroes_alarms', 'fx/adventure_heroes_alarms.mp3'],
  ['adventure_heroes_ambiance', 'fx/adventure_heroes_ambiance.mp3'],
  ['adventure_heroes_dinosaur', 'fx/adventure_heroes_dinosaur.mp3'],
  ['adventure_heroes_electricity', 'fx/adventure_heroes_electricity.mp3'],
  ['adventure_heroes_explosion', 'fx/adventure_heroes_explosion.mp3'],
  ['adventure_heroes_footsteps', 'fx/adventure_heroes_footsteps.mp3'],
  ['adventure_heroes_lab', 'fx/adventure_heroes_lab.mp3'],
  ['adventure_heroes_laughing', 'fx/adventure_heroes_laughing.mp3'],
  ['adventure_heroes_rain', 'fx/adventure_heroes_rain.mp3'],
  ['adventure_heroes_steam', 'fx/adventure_heroes_steam.mp3'],
  ['adventure_heroes_thunder', 'fx/adventure_heroes_thunder.mp3'],
  ['adventure_heroes_ticking_clocks', 'fx/adventure_heroes_ticking_clocks.mp3'],

  ['world_heroes_ambiance', 'fx/world_heroes_ambiance.mp3'],
  ['world_heroes_birds', 'fx/world_heroes_birds.mp3'],
  ['world_heroes_seagulls', 'fx/world_heroes_seagulls.mp3'],
  ['world_heroes_water', 'fx/world_heroes_water.mp3'],
  ['world_heroes_cars', 'fx/world_heroes_cars.mp3'],
  ['world_heroes_construction_jack_hammer', 'fx/world_heroes_construction_jack_hammer.mp3'],
  ['world_heroes_construction_piling', 'fx/world_heroes_construction_piling.mp3'],
  ['world_heroes_construction_tools', 'fx/world_heroes_construction_tools.mp3'],
  ['world_heroes_construction_trucks', 'fx/world_heroes_construction_trucks.mp3'],
  ['world_heroes_fire_1', 'fx/world_heroes_fire_1.mp3'],
  ['world_heroes_fire_2', 'fx/world_heroes_fire_2.mp3'],
  ['world_heroes_fountain', 'fx/world_heroes_fountain.mp3'],
  ['world_heroes_helicopters', 'fx/world_heroes_helicopters.mp3'],
  ['world_heroes_robots', 'fx/world_heroes_robots.mp3'],
  ['world_heroes_ship', 'fx/world_heroes_ship.mp3'],
  ['world_heroes_siren_1', 'fx/world_heroes_siren_1.mp3'],
  ['world_heroes_siren_2', 'fx/world_heroes_siren_2.mp3'],
  ['world_heroes_siren_3', 'fx/world_heroes_siren_3.mp3'],
  ['world_heroes_stadium_crater', 'fx/world_heroes_stadium_crater.mp3'],
  ['world_heroes_stadium_crowd', 'fx/world_heroes_stadium_crowd.mp3'],
  ['world_heroes_station_announcements', 'fx/world_heroes_station_announcements.mp3'],
  ['world_heroes_tower', 'fx/world_heroes_tower.mp3'],
  ['world_heroes_walking', 'fx/world_heroes_walking.mp3'],
]);